import { ICurrentStock, IProduct } from "@sbi-international/boutik.gatsby.plugin.services";
import { CookieConsentShowModalType } from "@sbi-international/boutik.package.cookie.consent/dist/models/cookieConsentShowModalType";
import dayjs from "dayjs";

declare module "dayjs" {
    interface Dayjs {
        isSameOrAfter(date: dayjs.ConfigType, unit?: dayjs.UnitType): boolean;
    }
}

export const productAvailabilityInfo = (product: IProduct, t: any, isCustomMade: boolean) => {
    if (!product?.currentStock?.instock)
        return {
            allowAddToCart: false,
            availabilityLabel: null,
            nextShipDate: null,
            addToCartVisible: false,
        };

    const now = dayjs();

    if (product?.currentStock?.status == "in-stock") {
        const shipsTomorrow = now.hour() < 15; //ship two day if hour is past 3pm

        let nextAvailableDate = shipsTomorrow ? now.add(1, "days") : now.add(2, "days");

        nextAvailableDate = roundToNextWeekday(nextAvailableDate);

        const nextAvailableDateString = nextAvailableDate.format("YYYY-MM-DD");
        return {
            allowAddToCart: true,
            availabilityLabel: t("available"),
            nextShipDate: nextAvailableDateString,
            addToCartVisible: true,
        };
    }

    if (product?.currentStock?.status == "preorder") {
        const nextAvailableDate = roundToNextWeekday(
            dayjs(product?.currentStock?.availabilityDate)
        );

        if (nextAvailableDate.isSameOrAfter(now)) {
            const nextAvailableDateString = nextAvailableDate.format("YYYY-MM-DD");
            return {
                allowAddToCart: true,
                availabilityLabel: t("next-availability") + "\n" + nextAvailableDateString,
                nextShipDate: nextAvailableDateString,
                addToCartVisible: true,
            };
        }
    }

    if (isCustomMade && isCustomMade === t("yes")) {
        let nextAvailableDate = now.add(4, "weeks");

        nextAvailableDate = roundToNextWeekday(nextAvailableDate);

        const nextAvailableDateString = nextAvailableDate.format("YYYY-MM-DD");
        return {
            allowAddToCart: true,
            availabilityLabel: t("next-availability") + "\n" + nextAvailableDateString,
            nextShipDate: nextAvailableDateString,
            addToCartVisible: true,
        };
    }

    return {
        allowAddToCart: false,
        availabilityLabel: t("not-available"),
        nextShipDate: null,
        addToCartVisible: true,
    };
};

export const productLiveAvailabilityLabel = (
    currentStock: ICurrentStock,
    t: any,
    isCustomMade: boolean
) => {
    if (!currentStock?.status == undefined) return '';

    const now = dayjs();

    if (currentStock?.status == "in-stock") {
        return t("available");
    }

    if (currentStock?.status == "preorder") {
        const nextAvailableDate = roundToNextWeekday(dayjs(currentStock?.availabilityDate));

        if (nextAvailableDate.isSameOrAfter(now)) {
            const nextAvailableDateString = nextAvailableDate.format("YYYY-MM-DD");
            return t("next-availability") + "\n" + nextAvailableDateString;
        }
    }

    if (isCustomMade && isCustomMade === t("yes")) {
        let nextAvailableDate = now.add(4, "weeks");

        nextAvailableDate = roundToNextWeekday(nextAvailableDate);

        const nextAvailableDateString = nextAvailableDate.format("YYYY-MM-DD");
        return t("next-availability") + "\n" + nextAvailableDateString;
    }

    return t("not-available");
        
};

export function roundToNextWeekday(nextAvailableDate: dayjs.Dayjs) {
    if (nextAvailableDate.day() === 0)
        //sunday
        nextAvailableDate = nextAvailableDate.add(1, "days");
    else if (nextAvailableDate.day() === 6)
        //saturday
        nextAvailableDate = nextAvailableDate.add(2, "days");
    return nextAvailableDate;
}
 
export function getAvailability(currentStock?:  ICurrentStock): "preorder" | "in-stock" | "out-of-stock" {
    return currentStock?.status && currentStock?.status != "unknown"
                                ? currentStock?.status
                                : "out-of-stock"
}